import { useEffect, useMemo, useState } from "react"

const useCountdown = (targetDate, showDays = false) => {
  const targetDateTime = useMemo(() => new Date(targetDate), [targetDate])

  const [countdown, setCountdown] = useState(targetDateTime - Date.now())

  useEffect(() => {
    setCountdown(targetDateTime - Date.now())

    const interval = setInterval(() => {
      const diff = targetDateTime - Date.now()

      if (diff > 0) {
        setCountdown(diff)
      } else {
        setCountdown(0)
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetDateTime])

  const hours = showDays
    ? Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    : Math.floor(countdown / (1000 * 60 * 60))
  const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countdown % (1000 * 60)) / 1000)

  const sectors = {
    ...(showDays
      ? { days: Math.floor(countdown / (1000 * 60 * 60 * 24)) }
      : {}),
    hours,
    minutes,
    seconds,
  }

  return Object.fromEntries(
    Object.entries(sectors).map(([key, value]) => [
      key,
      value >= 10 ? String(value) : value > 0 ? `0${value}` : "00",
    ])
  )
}

export default useCountdown
